const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Collapse per-record path segments (uuids, numeric ids) to `:id` so API
 * analytics events group by endpoint instead of exploding into one property
 * value per patient/cycle/document. Events also carry the full `url` alongside
 * this grouped `path`.
 */
export function normalizeApiPath(pathname: string): string {
  return pathname
    .split("/")
    .map((segment) =>
      UUID_SEGMENT.test(segment) || /^\d+$/.test(segment) ? ":id" : segment,
    )
    .join("/");
}
